import { render } from "./CustomInputUploadImage.vue?vue&type=template&id=c61f94b2&scoped=true"
import script from "./CustomInputUploadImage.vue?vue&type=script&lang=js"
export * from "./CustomInputUploadImage.vue?vue&type=script&lang=js"

import "./CustomInputUploadImage.vue?vue&type=style&index=0&id=c61f94b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61f94b2"]])

export default __exports__